import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Lock, ShieldCheck } from 'lucide-react';
import { api } from '../../../api/client';
import ErrorBanner from '../../../components/ErrorBanner';
import { toast } from '../../../lib/toast';

export default function SecuritySection() {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');

  const mutation = useMutation({
    mutationFn: ({ currentPassword, newPassword }) =>
      api.put('/api/me/password', { currentPassword, newPassword }).then((r) => r.data),
    onSuccess: () => {
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setError('');
      toast.success('Password updated');
    },
    onError: (err) => {
      setError(err.response?.data?.error || 'Could not update password');
    },
  });

  const onSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword.length < 8) {
      setError('New password must be at least 8 characters');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    mutation.mutate({ currentPassword: form.currentPassword, newPassword: form.newPassword });
  };

  return (
    <div className="card">
      <div className="section-header">
        <div className="section-title">
          <span className="section-icon">
            <Lock className="w-4 h-4" />
          </span>
          Security
        </div>
      </div>

      <div>
        <label className="label">Change password</label>
        <p className="text-xs text-ink-400 mb-3">
          Update your account password. You&apos;ll stay signed in on this device.
        </p>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="label">Current password</label>
            <input
              className="input"
              type="password"
              required
              autoComplete="current-password"
              value={form.currentPassword}
              onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
            />
          </div>
          <div>
            <label className="label">New password</label>
            <input
              className="input"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={form.newPassword}
              onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
            />
          </div>
          <div>
            <label className="label">Confirm new password</label>
            <input
              className="input"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={form.confirmPassword}
              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
            />
          </div>
          {error && <ErrorBanner body={error} onDismiss={() => setError('')} />}
          <div>
            <button type="submit" className="btn-primary" disabled={mutation.isPending}>
              <ShieldCheck className="w-4 h-4" />
              {mutation.isPending ? 'Updating…' : 'Update password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
